module.exports = __webpack_public_path__ + "static/media/relay-icon.2d9694a2.png";